export type Tab = 'compete' | 'fixtures' | 'table' | 'stages';

export function parseTab(raw: string | null): Tab {
  return raw === 'fixtures' || raw === 'table' || raw === 'stages' ? raw : 'compete';
}
